import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const getAllInquiries = createAsyncThunk(
  "Inquiries/FindAllInquiries",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/FindAllInquiries`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Inquiries:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// export const createInquiry = createAsyncThunk(
//   "Inquiries/InsertInquiries",
//   async (InquiryData: any) => {
//     try {
//       const response = await axiosApiInstance.post(
//         `${API_URL}/Inquiries/InsertInquiries`,
//         InquiryData
//       );
//       SuccessToast(response.data?.Details || "Success");
//       return response.data;
//     } catch (error: any) {
//       ErrorToast(error?.response?.data?.Details || "Something went wrong");
//       console.error("Error creating Inquiry:", error);
//       return Promise.reject({
//         message: error?.response?.data?.Details || "Something went wrong",
//       });
//     }
//   }
// );

// export const updateInquiry = createAsyncThunk(
//   "Inquiries/UpdateInquiries",
//   async (InquiryData: any) => {
//     try {
//       const response = await axiosApiInstance.post(
//         `${API_URL}/Inquiries/UpdateInquiries`,
//         InquiryData
//       );
//       SuccessToast(response.data?.Details || "Success");
//       return response.data;
//     } catch (error: any) {
//       ErrorToast(error?.response?.data?.Details || "Something went wrong");
//       console.error("Error updating Inquiry:", error);
//       return Promise.reject({
//         message: error?.response?.data?.Details || "Something went wrong",
//       });
//     }
//   }
// );

export const deleteInquiry = createAsyncThunk(
  "Inquiries/DeleteInquiries",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/DeleteInquiries`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Inquiry", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getInquiryByID = createAsyncThunk(
  "Inquiries/FindByIDInquiries",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/FindByIDInquiries`,
        { ID },
      );

      return response.data?.Data as any;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const assignInquiryToUser = createAsyncThunk(
  "AssignedUser/InquiryAssignedUsers",
  async (InquiryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AssignedUser/InquiryAssignedUsers`,
        InquiryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Package Inqiuiries
export const createPackageInquiry = createAsyncThunk(
  "Inquiries/InsertPackageInquiries",
  async (InquiryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/InsertPackageInquiries`,
        InquiryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updatePackageInquiry = createAsyncThunk(
  "Inquiries/UpdatePackageInquiries",
  async (InquiryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/UpdatePackageInquiries`,
        InquiryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getPackageInquiryByID = createAsyncThunk(
  "Inquiries/FindByIDPackageInquiries",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/FindByIDPackageInquiries`,
        { ID },
      );

      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        ContactID: result?.ContactID,
        LeadID: result?.LeadID,
        RequirementType: result?.RequirementType,
        Initial: result?.Initial,
        FirstName: result?.FirstName,
        LastName: result?.LastName,
        EmailID: result?.EmailID,
        TypeofInquiry: result?.TypeofInquiry,
        MobileNo: result?.MobileNo,
        // GoingfromID: result?.GoingfromID,
        Goingfrom: result?.Goingfrom,
        DestinationID: result?.DestinationID ? +result?.DestinationID : null,
        FoodPreferenceID: result?.FoodPreferenceID,
        NoOfPax: result?.NoOfPax,
        NoOfNights: result?.NoOfNights,
        InquirySourceID: result?.InquirySourceID,
        Budget: result?.Budget,
        ExpClosureAmount: result?.ExpClosureAmount,
        HotelPreference: result?.HotelPreference
          ? result?.HotelPreference?.split(",")?.map((pref: any) =>
              pref?.trim(),
            )
          : "",
        QueryType: result?.QueryType,
        Remarks: result?.Remarks,
        ExpClosureDate: result?.ExpClosureDate
          ? moment(result?.ExpClosureDate, "YYYY-MM-DD")?.toDate()
          : "",
        TravelDate: result?.TravelDate
          ? moment(result?.TravelDate, "YYYY-MM-DD")?.toDate()
          : "",
        Travelers: result?.Travelers,
        City: result?.City,
        HotelRooms: result?.HotelRooms ? result?.HotelRooms : [],
      } as any;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Flight Inqiuiries
export const createFlightInquiry = createAsyncThunk(
  "Inquiries/InsertFlightsInquiries",
  async (InquiryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/InsertFlightsInquiries`,
        InquiryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateFlightInquiry = createAsyncThunk(
  "Inquiries/UpdateFlightsInquiries",
  async (InquiryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/UpdateFlightsInquiries`,
        InquiryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getFlightInquiryByID = createAsyncThunk(
  "Inquiries/FindByIDFlightInquiries",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/FindByIDFlightInquiries`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        ContactID: result?.ContactID,
        LeadID: result?.LeadID,
        Initial: result?.Initial,
        FirstName: result?.FirstName,
        LastName: result?.LastName,
        EmailID: result?.EmailID,
        TypeofInquiry: result?.TypeofInquiry,
        MobileNo: result?.MobileNo,
        RequirementType: result?.RequirementType,
        ExpClosureAmount: result?.ExpClosureAmount,
        ExpClosureDate: result?.ExpClosureDate
          ? moment(result?.ExpClosureDate, "YYYY-MM-DD")?.toDate()
          : "",
        InquirySourceID: result?.InquirySourceID,
        TripType: result?.TripType,
        FromPlaceID: result?.FromPlaceID,
        ToPlaceID: result?.ToPlaceID,
        DepartureDate: result?.DepartureDate
          ? moment(result?.DepartureDate, "YYYY-MM-DD")?.toDate()
          : "",
        ReturnDate: result?.ReturnDate
          ? moment(result?.ReturnDate, "YYYY-MM-DD")?.toDate()
          : "",
        Adult: result?.Adult ? `${result?.Adult}` : null,
        Child: result?.Child !== 0 ? `${result?.Child}` : "zero",
        Infant: result?.Infant !== 0 ? `${result?.Infant}` : "zero",
        FlightClassID: result?.FlightClassID,
        PreferredAirlineID: result?.PreferredAirlineID
          ? result?.PreferredAirlineID?.split(", ")?.map(
              (flight: any) => +flight,
            )
          : "",
        Remarks: result?.Remarks,
        from_place_options: result?.from_place_options || [],
        to_place_options: result?.to_place_options || [],
      } as any;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Visa Inqiuiries
export const createVisaInquiry = createAsyncThunk(
  "Inquiries/InsertVisaInquiries",
  async (InquiryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/InsertVisaInquiries`,
        InquiryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateVisaInquiry = createAsyncThunk(
  "Inquiries/UpdateVisaInquiries",
  async (InquiryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/UpdateVisaInquiries`,
        InquiryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getVisaInquiryByID = createAsyncThunk(
  "Inquiries/FindByIDVisaInquiries",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/FindByIDVisaInquiries`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        ContactID: result?.ContactID,
        LeadID: result?.LeadID,
        Initial: result?.Initial,
        FirstName: result?.FirstName,
        LastName: result?.LastName,
        EmailID: result?.EmailID,
        TypeofInquiry: result?.TypeofInquiry,
        MobileNo: result?.MobileNo,
        RequirementType: result?.RequirementType,
        InquirySourceID: result?.InquirySourceID,
        Adult: result?.Adult ? `${result?.Adult}` : null,
        Child: result?.Child !== 0 ? `${result?.Child}` : "zero",
        Infant: result?.Infant !== 0 ? `${result?.Infant}` : "zero",
        Remarks: result?.Remarks,
        InquirySource: result?.InquirySource,
        CountryID: result?.CountryID,
        CountryName: result?.CountryName,
        VisaCategoryID: result?.VisaCategoryID,
        VisaCategory: result?.VisaCategory,
        EntryType: result?.EntryType,
        EntryTypeID: result?.EntryTypeID,
        DateofTravel: result?.DateofTravel
          ? moment(result?.DateofTravel, "YYYY-MM-DD").toDate()
          : "",
        Duration: result?.Duration,
        NationalityID: result?.NationalityID,
        Nationality: result?.Nationality,
      } as any;
    } catch (error: any) {
      console.error("Error Fetching Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Hotel Inqiuiries
export const createHotelInquiry = createAsyncThunk(
  "Inquiries/InsertHotelInquiries",
  async (InquiryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/InsertHotelInquiries`,
        InquiryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateHotelInquiry = createAsyncThunk(
  "Inquiries/UpdateHotelInquiries",
  async (InquiryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/UpdateHotelInquiries`,
        InquiryData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getHotelInquiryByID = createAsyncThunk(
  "Inquiries/FindByIDHotelInquiries",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/FindByIDHotelInquiries`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        ContactID: result?.ContactID,
        LeadID: result?.LeadID,
        Initial: result?.Initial,
        FirstName: result?.FirstName,
        LastName: result?.LastName,
        EmailID: result?.EmailID,
        TypeofInquiry: result?.TypeofInquiry,
        MobileNo: result?.MobileNo,
        RequirementType: result?.RequirementType,
        InquirySourceID: result?.InquirySourceID,
        Remarks: result?.Remarks,
        InquirySource: result?.InquirySource,
        NationalityID: result?.NationalityID,
        Nationality: result?.Nationality,
        CityID: result?.CityID,
        HotelID: result?.HotelID,
        RoomTypeID: result?.RoomTypeID,
        DestinationName: result?.DestinationName,
        CheckIn: result?.CheckIn
          ? moment(result?.CheckIn, "YYYY-MM-DD").toDate()
          : "",
        CheckOut: result?.CheckOut
          ? moment(result?.CheckOut, "YYYY-MM-DD").toDate()
          : "",
        NoOfNights: result?.NoOfNights,
        Travelers: result?.Travelers,
        StarRating: result?.StarRating,
        MealTypeID: result?.MealTypeID,
        FoodPreference: result?.FoodPreference,
        HotelRooms: result?.HotelRooms ? result?.HotelRooms : [],
      } as any;
    } catch (error: any) {
      console.error("Error Fetching Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertFollowUp = createAsyncThunk(
  "Inquiries/InsertFollowup",
  async (FollowUpData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/InsertFollowup`,
        FollowUpData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error inserting followup:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateFollowUpStatus = createAsyncThunk(
  "Inquiries/FollowupStatusUpdate",
  async (FollowUpData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/FollowupStatusUpdate`,
        FollowUpData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating followup status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateInquiryStatus = createAsyncThunk(
  "Inquiries/UpdateInquiryType",
  async (FollowUpData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/UpdateInquiryType`,
        FollowUpData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating followup status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateInquiryStageStatus = createAsyncThunk(
  "Inquiries/UpdateInquiryStage",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/UpdateInquiryStage`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating inquiry status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getFollowupsByInquiryID = createAsyncThunk(
  "Inquiries/FollowupListByID",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiries/FollowupListByID`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Inquiries:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getInquiryAssignUserHistory = createAsyncThunk(
  "AssignedUser/InquiryAssignHistory",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AssignedUser/InquiryAssignHistory`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Assign User History:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
